import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full px-5 py-14 sm:py-20" data-id="element-160" data-mp="1hduloasc2p61">
      <div className="mx-auto max-w-2xl" data-id="element-161" data-mp="1cf9lgbd305hl">
        <h2 className="text-center font-display text-2xl font-bold text-ink sm:text-4xl" data-id="element-162" data-mp="1cgb87d3gmgf5">
          Najczęstsze pytania
        </h2>

        <div className="mt-8 divide-y divide-chem/15 border-y border-chem/15" data-id="element-163" data-mp="253f5sx083sgw">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} data-id="element-164" data-mp="2027y0xy2yta8" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex min-h-[52px] w-full items-center justify-between gap-4 py-4 text-left" data-id="element-165" data-mp="1v583nkalfeyy">
                  <span className="text-sm font-semibold text-ink sm:text-base" data-id="element-166" data-mp="jpsxpr0epcrp">{faq.question}</span>
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-chem/12 text-chem-deep" data-id="element-167" data-mp="1knqh5dlbla0b">
                    {isOpen ? <MinusIcon className="h-4 w-4" aria-hidden="true" data-id="element-168" data-mp="1pls2k567xley" /> : <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-169" data-mp="1apkid4ut8jzo" />}
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-170" data-mp="1fo45h8l541tm">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-171" data-mp="1fqqb32oh0797">
                      <p className="pb-4 text-sm leading-relaxed text-ink/70" data-id="element-172" data-mp="wvtae0wq9862">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}